import {
  HStack,
  Box,
  Text,
  Flex,
  BoxProps,
  useColorModeValue,
  Card,
  CardHeader,
  CardBody,
  Skeleton,
} from '@chakra-ui/react';
import React from 'react';
import { PieChart, Pie } from 'recharts';

import { colors } from '~/packages/common-frontend/colors';

export const InfoCard = ({
  title,
  value,
  loading,
  ...otherBoxProps
}: {
  title: string;
  value: React.ReactNode;
  loading: boolean;
} & BoxProps) => {
  const bgColor = useColorModeValue('white', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue(colors.gray[200], colors.gray[600]);

  return (
    <Card
      bg={bgColor}
      borderRadius="8px"
      p="16px 24px"
      boxShadow="sm"
      borderWidth="1px"
      borderColor={borderColor}
      {...otherBoxProps}
    >
      <CardHeader p="0">
        <HStack spacing="8px">
          <Text fontSize="md" color={textColor}>
            {title}
          </Text>
        </HStack>
      </CardHeader>

      <CardBody p="0">
        <Skeleton isLoaded={!loading}>
          <Text fontSize="3xl" fontWeight="bold" color={textColor}>
            {value}
          </Text>
        </Skeleton>
      </CardBody>
    </Card>
  );
};

const legendColors = {
  issuesAcknowledged: colors.green[200],
  issuesUnacknowledged: colors.red[200],
};
export const CDQChartPanel = ({
  issuesAcknowledged,
  issuesUnacknowledged,
  loading,
}: {
  issuesAcknowledged: number;
  issuesUnacknowledged: number;
  loading: boolean;
}) => {
  return (
    <Box w="100%">
      <HStack w="100%" justify="flex-start" p="40px" spacing="40px" h="100%">
        <PieChart width={320} height={320}>
          <Pie
            width={220}
            height={220}
            data={[
              {
                name: 'Issues Unacknowledged',
                value: issuesUnacknowledged,
                fill: legendColors.issuesUnacknowledged,
              },
              {
                name: 'Issues Acknowledged',
                value: issuesAcknowledged,
                fill: legendColors.issuesAcknowledged,
              },
            ]}
            dataKey="value"
            nameKey="name"
          />
        </PieChart>

        <Flex direction="column" flex="1" justify="space-evenly">
          <HStack w="100%" spacing="40px">
            <InfoCard
              title="Issues Acknowledged"
              value={String(issuesAcknowledged)}
              w="100%"
              loading={loading}
            />

            <InfoCard
              title="Issues Unacknowledged"
              value={String(issuesUnacknowledged)}
              w="100%"
              loading={loading}
            />
          </HStack>
          <HStack spacing="8px" mt="24px">
            <Box
              w="12px"
              h="12px"
              bg={legendColors.issuesAcknowledged}
              borderRadius="full"
            />
            <Text fontSize="md">Issues Acknowledged</Text>
          </HStack>
          <HStack spacing="8px">
            <Box
              w="12px"
              h="12px"
              bg={legendColors.issuesUnacknowledged}
              borderRadius="full"
            />
            <Text fontSize="md">Issues Unacknowledged</Text>
          </HStack>
        </Flex>
      </HStack>
    </Box>
  );
};
